"use client";

import { useCallback } from "react";
import { useWebSiteContext } from "@core/helpers/client/contexts/WebSiteContext";
import { get_cap_token } from "@core/helpers/client/captcha";

// get_captcha_token() resolves to a Cap token when the site has the "CAP" service, and to undefined when it
// does not, so a mutation can always put it in its variables.
const useCapToken = () => {
  const { check_service_access } = useWebSiteContext() || {};
  const captcha_enabled = !!check_service_access?.("CAP");

  const get_captcha_token = useCallback(
    async (options) => (captcha_enabled ? await get_cap_token(options) : undefined),
    [captcha_enabled]
  );

  return { captcha_enabled, get_captcha_token };
};

export default useCapToken;
